module.exports = __webpack_public_path__ + "static/img/Send20.178cde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send20.png
// module id = Uleu
// module chunks = 0